/**
 * ItemHistoryLineageView
 *
 * Visual timeline (top) + tabular change log (bottom), stacked.
 * The journey link lives in the timeline card header (via ItemLineageTimeline).
 */

import { Clock } from 'lucide-react';
import { ItemLineageTimeline } from '../../ItemLineageTimeline';
import { HistoryTab } from './HistoryTab';
import { ItemOutcomeBanner } from '../ItemOutcomeLine';

// ─── Component ────────────────────────────────────────────────────────────────

interface Props {
  itemId: string;
  className?: string;
}

export function ItemHistoryLineageView({ itemId, className = '' }: Props) {
  return (
    <div className={className}>
      {/* What happened to it, when it has left active consideration (S-27) */}
      <ItemOutcomeBanner itemId={itemId} className="mb-4" />

      {/* Visual timeline — journey link is in the card header */}
      <ItemLineageTimeline itemId={itemId} />

      {/* Tabular change log */}
      <div className="mt-4 border-t border-[var(--rule)] pt-4">
        <p className="text-xs font-semibold text-[var(--text-ter)] uppercase tracking-wide mb-2 flex items-center gap-1.5">
          <Clock className="h-3 w-3" />
          History
        </p>
        <HistoryTab itemId={itemId} />
      </div>
    </div>
  );
}
